module.exports = __webpack_public_path__ + "std/img/grzx_bg.774a920.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/My/grzx_bg.png
// module id = g+cf
// module chunks = 0